<template>
  <div style="width: 100vw; height: 100%;">
    <el-row v-if="mapOptionCode === this.$mapType.SI_DO" style="width: 100%; height: 100%">
      <el-col style="width: 100%; height: 100%;" :span="12">
        <Map map-id="koreaMap" :map-type="mapOptionCode"></Map>
      </el-col>
    </el-row>

    <el-row v-if="mapOptionCode === this.$mapType.COMPARE && mapStatItemYearList.length == 0" style="width: 100%; height: 100%;">
      <el-col :span="24" style="height: 100%;">
        <Map map-id="koreaMap" :map-type="mapOptionCode"></Map>
      </el-col>
    </el-row>
    <el-row v-if="mapOptionCode === this.$mapType.COMPARE && mapStatItemYearList.length > 0" style="width: 100%; height: 100%;">
      <el-col v-for="year in mapStatItemYearList" :key="year" :span="24/mapStatItemYearList.length" style="height: 100%;">
        <MapCompare :map-id="'compare_' + year" :map-year="year" :map-type="mapOptionCode"></MapCompare>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import Map from '@/components/Map'
import MapCompare from '@/components/MapCompare'

import commonUI from '@/mixin/commonUI'
import { eventBus } from '@/event-bus'
import { mapGetters } from 'vuex'

const statItemStore = 'statItemStore'

export default {
  name: 'Main',
  mixins: [commonUI],
  components: {
    Map,
    MapCompare,
  },
  data () {
    return {
      mapOptions: [],
      mapOptionCode: '',
      mapCompareRowCnt: 0,
      mapCompareColCnt: 0,
      mapStatItemYearList: []

    }
  },
  computed: {
    ...mapGetters(statItemStore, {
      selectedYearList: 'selectedYearList'
    })
  },
  mounted: function () {
  },
  destroyed () {
  },
  created () {
    this.mapOptionCode = this.$mapType.SI_DO

    eventBus.$on('sendMapOptions', (mapOptions) => {
      this.mapStatItemYearList = this.selectedYearList
      if (mapOptions.length > 0) {
        this.mapOptionCode = mapOptions[0]
      } else {
        this.mapOptionCode = this.$mapType.SI_DO
      }
    })
  },

  watch: {
    selectedYearList (val) {
      this.mapStatItemYearList = val
    }
  },

  methods: {
  }
}
</script>

<style scoped>

</style>
